import getApiInstance from '@/services/Api'
import { useRetirementCalculator } from '@/composables/useRetirementCalculator'

const api = getApiInstance()

export default {
  getProfile() {
    return api.Get('/profile')
  },

  getStates() {
    return api.Get('/state')
  },

  putPartnerInfo(payload) {
    return api.Put('/partner', payload)
  },

  removePartnerData(payload) {
    return api.Post('/partner/remove', payload)
  },

  getCashFlow() {
    return api.Get('/cashflow')
  },

  getFinancialSummary() {
    return api.Get('/modularised_advice/financial-summary')
  },

  updateFinancialSummary(
    type: 'salaryAndSuper' | 'otherIncome' | 'assets' | 'debt' | 'expenses',
    payload: Record<string, unknown>
  ) {
    return api.Put('/modularised_advice/financial-summary', { type, payload })
  },

  getDependents() {
    return api.Get('/dependents')
  },

  addDependent(payload) {
    return api.Put('/save-dependents', payload)
  },

  removeDependent(id: string | number) {
    return api.Delete(`/dependents/${id}`)
  },
}
